import styled from 'styled-components';
import { Label1, Body } from '../Typography/Text.js';
const BoldLabel = styled(Label1)`
  font-weight: 500;
  line-height: 16px;
  color: ${p => p.theme.color.text};
  &:hover {
    color: ${p => p.theme.color.text};
  }
`;
const NavBodyBold = styled(Body)`
  font-weight: 500;
  line-height: 16px;
`;
const NavBody = styled(Body)`
  line-height: 16px;
`;
export { BoldLabel, NavBody, NavBodyBold };
//# sourceMappingURL=NavTypography.js.map
